import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AuditLog() {
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    api.get("/admin/audit").then((r) => setEntries(r.data)).catch(() => toast.error("Could not load audit log"));
  }, []);

  if (!entries) return <div className="h-8 w-8 border-4 border-steel border-t-lomond rounded-full animate-spin" data-testid="audit-loading" />;

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-lomond mb-1">Admin</p>
        <h1 className="font-heading font-extrabold uppercase tracking-tight text-charcoal text-2xl sm:text-3xl" data-testid="audit-heading">Audit Log</h1>
        <p className="text-sm text-slate-500 mt-1">Approvals, assessment overrides, progression decisions and admin changes.</p>
      </div>
      <div className="bg-slate-panel border border-steel rounded-sm overflow-x-auto" data-testid="audit-table-wrapper">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="border-b border-steel text-left">
              {["When", "Actor", "Action", "Details"].map((h) => (
                <th key={h} className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-slate-500">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id} className="border-b border-steel" data-testid={`audit-row-${e.id}`}>
                <td className="px-4 py-2.5 text-xs font-mono text-slate-500 whitespace-nowrap">{new Date(e.at).toLocaleString("en-GB")}</td>
                <td className="px-4 py-2.5 text-xs text-slate-600">{e.actor_email}</td>
                <td className="px-4 py-2.5 text-xs font-mono uppercase tracking-widest text-lomond">{e.action.replace(/_/g, " ")}</td>
                <td className="px-4 py-2.5 text-xs text-slate-500">{e.details}</td>
              </tr>
            ))}
            {!entries.length && (
              <tr><td colSpan={4} className="px-4 py-10 text-center text-slate-500 text-sm" data-testid="audit-empty">No audit entries yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
